export const partyKeys = {
	all: ['parties'] as const,
	active: () => [...partyKeys.all, 'active'] as const,
};
